// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as ApiUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as ErrorUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";
import * as AuthVm$PorterinFeature from "../../../../../view-model/AuthVm.mjs";
import * as CookieStore$PorterinFeature from "../../../../../../fare-estimate-v1/utils/browser/CookieStore.mjs";
import * as CookieUtils$PorterinFeature from "../../../../../../fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as Lib$PorterinFusionkitSentry from "../../../../../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as AuthRepoManager$PorterinFeature from "../../../../../domain/repo/AuthRepoManager.mjs";
import * as CustomErrorUtils$PorterinFeature from "../../../../../../order-review/domain/helpers/CustomErrorUtils.mjs";
import * as FareEstimateResultFormHelper$PorterinFeature from "../../../../../../../shared/core/helpers/FareEstimateResultFormHelper.mjs";

function initialFormState(number) {
  return {
          mobile: number
        };
}

function onFormSubmit(output, callbacks, setResponse, set_auth_state, query_params, set_user, is_mobile_number_updated, prefill, set_form_prefill) {
  var RepoInstance = AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
  var webTrackingId = CookieUtils$PorterinFeature.getCookie(CookieStore$PorterinFeature.web_tracking_id);
  var form_data = {
    mobile: output.mobile
  };
  Curry._1(set_user, {
        auth_token: undefined,
        mobile: form_data.mobile,
        name: AuthVm$PorterinFeature.prefillName(prefill),
        requirement_type: AuthVm$PorterinFeature.prefillRequirementType(prefill),
        email: undefined,
        whatsapp_consent: undefined
      });
  var setAuthState = function (param) {
    ApiUtils$Catalyst.handleAPIRequest((function (param) {
            return Curry._3(RepoInstance.checkCustomerExists, webTrackingId, form_data.mobile, query_params);
          }), (function (data) {
            if (prefill !== undefined) {
              Curry._1(set_form_prefill, (function (param) {
                      return {
                              mobile: form_data.mobile,
                              name: prefill.name,
                              requirement_type: prefill.requirement_type
                            };
                    }));
            } else {
              Curry._1(set_form_prefill, (function (param) {
                      
                    }));
            }
            Curry._1(callbacks.notifyOnSuccess, undefined);
            if (data.status === true) {
              return Curry._1(set_auth_state, (function (param) {
                            return /* OtpValidationV2 */6;
                          }));
            } else {
              return Curry._1(set_auth_state, (function (param) {
                            return /* SignupScreenV2 */5;
                          }));
            }
          }), (function (error) {
            var match = CustomErrorUtils$PorterinFeature.getErrorEntity(error);
            var exit = 0;
            if (typeof match === "number" || match.TAG !== /* UnprocessedEntity */1) {
              exit = 1;
            } else {
              Curry._1(setResponse, (function (param) {
                      return {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            };
                    }));
            }
            if (exit === 1) {
              Curry._1(setResponse, (function (param) {
                      return {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            };
                    }));
            }
            Curry._1(callbacks.notifyOnFailure, error);
          }));
  };
  if (is_mobile_number_updated) {
    Js_promise.$$catch((function (error) {
            Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, error.toString());
            return Promise.resolve(undefined);
          }), Js_promise.then_((function (customer_exist_flag) {
                if (customer_exist_flag !== undefined) {
                  if (customer_exist_flag) {
                    setAuthState(undefined);
                  } else {
                    if (prefill !== undefined) {
                      Curry._1(set_form_prefill, (function (param) {
                              return {
                                      mobile: form_data.mobile,
                                      name: prefill.name,
                                      requirement_type: prefill.requirement_type
                                    };
                            }));
                    } else {
                      Curry._1(set_form_prefill, (function (param) {
                              
                            }));
                    }
                    Curry._1(set_auth_state, (function (param) {
                            return /* SignupScreenV2 */5;
                          }));
                  }
                } else {
                  Curry._1(set_auth_state, (function (param) {
                          return /* SignupScreenV2 */5;
                        }));
                }
                return Promise.resolve(undefined);
              }), FareEstimateResultFormHelper$PorterinFeature.getCustomerExistInfo(form_data.mobile)));
    return ;
  } else {
    return setAuthState(undefined);
  }
}

export {
  initialFormState ,
  onFormSubmit ,
}
/* CookieUtils-PorterinFeature Not a pure module */
